import Helper from "./Helper";

class Anchor {
  constructor() {
    let anchors = document.querySelectorAll('.ns-link--anchor');
    this.headerHeight = document.querySelector('.header').clientHeight;

    anchors = Array.prototype.slice.call(anchors);

    if (anchors) {
      this.bindEvents(anchors);
    }
  }

  bindEvents(anchors) {
    this.bindClick(anchors);
  }

  bindClick(anchors) {
      anchors.forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();

          const targetUrl = item.getAttribute('href');
          const targetId = targetUrl.split('#')

          this.scroll(targetId);
        });
      });
  }

  scroll(targetId) {
    const yOffset = this.headerHeight;
    const targetID = document.getElementById(targetId[1]);
    const y = targetID.getBoundingClientRect().top + window.pageYOffset - yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
}

export default Anchor;
